import shuffle from "lodash/shuffle";

import {
  ExploreThemeType,
  NonShareableResourceTitles,
  PreserveOrderContentThemeCodes,
} from "@/constants/Explore";

/**
 * Determines if a resource is shareable based on its title.
 * Some resources are restricted from sharing due to business rules.
 *
 * @param title - The title of the resource to check
 * @returns true if the resource can be shared, false if sharing is restricted
 */
const isResourceShareable = (title: string): boolean => {
  return !Object.values(NonShareableResourceTitles).some(
    (nonShareableTitle) =>
      nonShareableTitle.toLowerCase() === title.toLowerCase(),
  );
};

// Helper function to get Most Popular Videos resources
const getMostPopularVideoResources = (themes: ResourceTheme[]): Resource[] => {
  const mostPopularTheme = themes.find(
    (theme) => theme.name === ExploreThemeType.MostPopularVideos,
  );
  return mostPopularTheme?.resources || [];
};

/**
 * Returns a copy of the theme with its resources shuffled, unless the theme's
 * code is one that is already ordered server-side (SOTW rotation, Daily Education, etc)
 * in which case the original resource order is preserved.
 */
const shuffleContentThemeResources = (theme: ResourceTheme): ResourceTheme => {
  if (PreserveOrderContentThemeCodes.has(theme.code)) {
    return { ...theme };
  }
  return { ...theme, resources: shuffle(theme.resources) };
};

export {
  getMostPopularVideoResources,
  isResourceShareable,
  shuffleContentThemeResources,
};
